// import axios from 'axios';
// import config from './config';

// let CLIENTBASEURL = axios.create({
//     baseURL: config.plexURL,  

// });

// let SMBASEURL = axios.create({
//     baseURL: config.clientURL, 

// });

// export default {CLIENTBASEURL,SMBASEURL}

import axios from 'axios';

export default axios.create({
  baseURL: `${process.env.REACT_APP_CLIENT_API_BASE_URL}/api/`
});
